export default "__VITE_ASSET__BiizDMA1__"